import { zetApi } from '@zet/network'

import { ExperimentForZetBanner, ZetReferralData } from './types'

export async function getZetReferralData(userId: number | undefined) {
  const { data } = await zetApi.get<ZetReferralData>(
    `ams/v1/zet-referral/${userId}`
  )
  return data?.data
}

export async function getExperimentForZetBanner(userId: number | undefined) {
  const { data } = await zetApi.get<ExperimentForZetBanner>(
    `ams/v1/experiment/evaluate/${userId}`
  )
  return data?.data
}
